import { useState } from 'react';
import { Link } from 'react-router-dom';

const footerNavGroups = [
  {
    title: '快速导航',
    links: [
      { label: '首页', href: '/' },
      { label: '分类大全', href: '/category' },
      { label: '排行榜', href: '/category?sort=ranking' },
      { label: '最新上架', href: '/category?sort=newest' },
    ],
  },
  {
    title: '热门分类',
    links: [
      { label: '恋爱韩漫', href: '/category?type=romance' },
      { label: '玄幻韩漫', href: '/category?type=fantasy' },
      { label: '动作韩漫', href: '/category?type=action' },
      { label: '悬疑韩漫', href: '/category?type=mystery' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '联系我们', href: '/about#contact' },
      { label: '用户协议', href: '/about' },
      { label: '隐私政策', href: '/about' },
    ],
  },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }

    setStatus('loading');
    setFormError('');

    try {
      const formData = new FormData(form);
      const formUrl = 'http://sansevieria.cn/';
      const response = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = {};
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        if (serverMsg && serverMsg.includes('spam')) {
          setStatus('success');
          setEmail('');
          return;
        }
        setStatus('error');
        setFormError(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setFormError('网络错误，请稍后重试');
    } finally {
      if (status === 'loading') {
        setStatus('idle');
      }
    }
  };

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="lg:w-1/3">
            <Link to="/" className="inline-flex items-center gap-2 mb-6 cursor-pointer">
              <span className="font-heading text-2xl font-bold text-background-50">
                尾巴漫画
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-sm">
              尾巴漫画网专注好看的韩国漫画，韩漫在线免费阅读体验流畅，高清无删减内容，下拉式设计让您沉浸其中。每日更新海量韩漫资源。
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-links-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="哔哩哔哩" rel="nofollow">
                <i className="ri-movie-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="小红书" rel="nofollow">
                <i className="ri-external-link-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="lg:w-2/3 grid grid-cols-2 md:grid-cols-3 gap-8">
            {footerNavGroups.map((group) => (
              <div key={group.title}>
                <h4 className="font-label text-sm font-semibold text-background-50 mb-4">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-3">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-foreground-300 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-10 border-t border-background-800/60">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <div className="w-32 h-16 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=cozy%20reading%20scene%20with%20tablet%20displaying%20colorful%20webtoon%20comic%2C%20warm%20ambient%20lighting%2C%20coffee%20cup%20nearby%2C%20comfortable%20atmosphere%2C%20clean%20minimal%20composition%2C%20soft%20focus&width=640&height=320&seq=footer-reading-scene&orientation=landscape"
                  alt="漫画阅读场景"
                  className="w-full h-full object-cover rounded-lg"
                />
              </div>
              <div>
                <p className="font-heading text-base text-background-200">
                  &copy; 2026 尾巴漫画网 All rights reserved.
                </p>
                <p className="text-foreground-400 text-xs mt-1">
                  专注韩国漫画在线阅读，高清无删减，每天更新
                </p>
              </div>
            </div>

            <div className="w-full md:w-auto">
              <p className="text-foreground-300 text-xs mb-3">订阅我们，获取最新韩漫更新通知</p>
              <form id="footer-subscribe-form" onSubmit={handleSubmit} className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入您的邮箱"
                  required
                  className="flex-1 min-w-0 px-4 py-2.5 bg-background-800 border border-background-700 rounded-full text-sm text-background-50 placeholder-foreground-500 outline-none focus:border-primary-400 transition-colors duration-200"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="absolute opacity-0 pointer-events-none"
                  style={{ position: 'absolute', left: '-9999px' }}
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer disabled:opacity-60"
                >
                  {status === 'loading' ? (
                    <span>发送中...</span>
                  ) : (
                    <span className="flex items-center gap-1.5">
                      订阅
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-right-line text-sm"></i>
                      </span>
                    </span>
                  )}
                </button>
              </form>
              {status === 'success' && (
                <p className="text-primary-400 text-xs mt-2">订阅成功！感谢您的关注。</p>
              )}
              {status === 'error' && (
                <p className="text-red-400 text-xs mt-2">{formError || '订阅失败，请稍后重试'}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}